import { NavLink } from "react-router-dom";
import "./Sidebar.css";

export default function Sidebar() {
  const linkClass = ({ isActive }) =>
    isActive ? "sidebar-link active" : "sidebar-link";

  return (
    <aside className="sidebar">
      <nav className="sidebar-menu">
        <NavLink to="/admin/dashboard" className={linkClass}>
          Dashboard
        </NavLink>

        <NavLink to="/admin/orders" className={linkClass}>
          Orders
        </NavLink>

        <NavLink to="/admin/products" className={linkClass}>
          Products
        </NavLink>

        <NavLink to="/admin/rfqs" className={linkClass}>
          RFQs
        </NavLink>

        <NavLink to="/admin/customers" className={linkClass}>
          Customers
        </NavLink>

        <NavLink to="/admin/login" className="sidebar-link logout">
          Logout
        </NavLink>
      </nav>
    </aside>
  );
}
